import React from "react";
import { withRouter } from "react-router-dom";
import { PageSettings } from "./../config/page-settings.js";
import { Api } from "./../app-controller.js";

class PasswordReset extends React.Component {
  static contextType = PageSettings;

  state = {
    email: "",
    password: "",
    password2: "",
    token: this.props.match.params[0],
    working: false,
    msg: "Verificando Solicitud.",
    form: false,
    error: "",
  };

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();

    if (this.state.password !== this.state.password2) {
      this.setState({ error: "Las contraseñas no concuerdan" });
    } else {
      this.setState({ working: true });
      Api.xhr(
        "public/passwordUpdate",
        {
          token: this.state.token,
          password: this.state.password,
        },
        (e) => {
          if (e) {
            if (e.msg === "ok") {
              this.setState({
                form: false,
                msg: "Contraseña actualizada",
                working: false,
              });
            }
          }
        }
      );
    }

    return false;
  }

  componentDidMount() {
    this.context.handleSetPageSidebar(false);
    this.context.handleSetPageHeader(false);
    this.context.handleSetPageContentFullWidth(true);

    this.setState({ working: true });
    Api.xhr(
      "public/verifyPasswordRequest",
      { token: this.state.token },
      (r) => {
        if (r) {
          this.setState({ working: false });
          if (r.error) {
            this.setState({ msg: r.error });
          } else {
            if (r.msg === "ok") {
              this.setState({
                msg: "Ingrese su nueva contraseña",
                form: true,
              });
            }
          }
        }
      }
    );
  }

  componentWillUnmount() {
    this.context.handleSetPageSidebar(true);
    this.context.handleSetPageHeader(true);
    this.context.handleSetPageContentFullWidth(false);
  }

  render() {
    return (
      <div className="login login-v1">
        <div className="login-container">
          <div className="login-header">
            <div className="brand">
              {/* <span className="logo " ></span>  */}
              <img
                className="logo"
                alt="Logo"
                style={{ width: "12%", height: "12%" }}
                src="../favicon.ico"
              ></img>
              <b>SINAIP</b>
            </div>
            <div className="icon">
              <i className="fa fa-user"></i>
            </div>
          </div>
          <div className="login-body">
            <div className="login-content">
              <div
                id="tag"
                className="note note-secundary note-with-right-icon"
              >
                <div className="note-icon">
                  <i className="fa fa-lock"></i>
                </div>
                <div className="note-content text-right">
                  <h4>
                    <b>{this.state.msg}</b>
                  </h4>

                  <div className={!this.state.working ? "hide" : ""}>
                    <div className="progress-bar bg-purple progress-bar-striped progress-bar-animated">
                      Por favor espere....
                    </div>
                  </div>

                  <form
                    className={!this.state.form ? "hide" : ""}
                    onSubmit={this.handleSubmit}
                  >
                    <div className="form-group m-b-15">
                      <input
                        type="password"
                        name="password"
                        value={this.state.password}
                        onChange={(e) =>
                          this.setState({ password: e.target.value })
                        }
                        className="form-control form-control-lg"
                        placeholder="Contraseña"
                        required
                      />
                    </div>
                    <div className="form-group m-b-15">
                      <input
                        type="password"
                        name="password2"
                        value={this.state.password2}
                        onChange={(e) =>
                          this.setState({ password2: e.target.value })
                        }
                        className="form-control form-control-lg"
                        placeholder="Repetir Contraseña"
                        required
                      />
                    </div>

                    <div
                      className={
                        this.state.error ? "badge badge-danger" : "hide"
                      }
                    >
                      <strong>{this.state.error}</strong>
                    </div>

                    <div className="login-buttons">
                      <button
                        type="submit"
                        className={
                          this.state.working
                            ? "btn btn-working btn-warning btn-block btn-lg"
                            : "btn btn-success btn-block btn-lg"
                        }
                      >
                        Cambiar contraseña
                      </button>
                    </div>
                    
                  </form>
                 
                </div>

                

              </div>
              <a href="/">
                <button className="btn btn-block btn-lg btn-primary m-t-10 ">
                  Ir a inicio
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(PasswordReset);
